import { AlertTriangle, ArrowRight, Info } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Alert, AlertAction, AlertTitle } from '@/customer/components/ui/alert'
import type { MembershipIssue, PetIssue } from '@/customer/lib/membership'

/**
 * Renders membership issue callouts.
 */
export function MembershipWarnings({ issues }: { issues: (MembershipIssue | PetIssue)[] }) {
  return (
    <div className="flex flex-col gap-3">
      {issues.map((w) => (
        <Alert key={`${w.type}:${w.action.href}`} variant={w.severity ?? 'warning'}>
          <AlertTitle className="flex items-center gap-2 text-body-md leading-none">
            {w.severity === 'info' ? (
              <Info className="size-5 shrink-0" aria-hidden />
            ) : (
              <AlertTriangle className="size-5 shrink-0" aria-hidden />
            )}
            {w.title}
          </AlertTitle>
          <AlertAction>
            <Link
              to={w.action.href}
              className="group inline-flex items-center gap-1 text-button-sm text-foreground underline underline-offset-4 hover:no-underline"
            >
              {w.action.label ?? w.title}
              <ArrowRight
                className="size-3 transition-transform group-hover:translate-x-0.5"
                aria-hidden
              />
            </Link>
          </AlertAction>
        </Alert>
      ))}
    </div>
  )
}
